function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 356,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M158.104 78H159.196V71.484H158.104V78ZM158.656 70.14C159.088 70.14 159.388 69.852 159.388 69.408C159.388 68.988 159.088 68.7 158.656 68.7C158.224 68.7 157.924 68.988 157.924 69.408C157.924 69.852 158.224 70.14 158.656 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M161.409 78H162.501V73.272C163.101 72.6 163.653 72.276 164.145 72.276C164.973 72.276 165.357 72.792 165.357 74.016V78H166.449V73.272C167.061 72.6 167.589 72.276 168.093 72.276C168.921 72.276 169.305 72.792 169.305 74.016V78H170.397V73.872C170.397 72.204 169.761 71.316 168.417 71.316C167.625 71.316 166.941 71.832 166.269 72.564C166.005 71.796 165.465 71.316 164.469 71.316C163.689 71.316 163.005 71.808 162.441 72.432H162.405L162.309 71.484H161.409V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M174.018 78.156C174.822 78.156 175.554 77.736 176.178 77.22H176.214L176.31 78H177.21V73.992C177.21 72.384 176.538 71.316 174.954 71.316C173.91 71.316 172.986 71.784 172.386 72.168L172.818 72.924C173.334 72.576 174.018 72.228 174.774 72.228C175.842 72.228 176.118 73.032 176.118 73.872C173.346 74.184 172.11 74.892 172.11 76.308C172.11 77.484 172.926 78.156 174.018 78.156ZM174.33 77.28C173.682 77.28 173.178 76.98 173.178 76.236C173.178 75.396 173.922 74.856 176.118 74.592V76.416C175.482 76.98 174.966 77.28 174.33 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M181.487 81C183.503 81 184.787 79.956 184.787 78.744C184.787 77.676 184.019 77.196 182.507 77.196H181.235C180.359 77.196 180.095 76.908 180.095 76.488C180.095 76.128 180.275 75.912 180.515 75.708C180.803 75.852 181.163 75.936 181.487 75.936C182.807 75.936 183.863 75.06 183.863 73.668C183.863 73.104 183.647 72.624 183.335 72.324H184.667V71.484H182.399C182.171 71.4 181.847 71.316 181.487 71.316C180.167 71.316 179.039 72.216 179.039 73.644C179.039 74.424 179.459 75.048 179.891 75.396V75.444C179.555 75.684 179.159 76.116 179.159 76.656C179.159 77.172 179.411 77.52 179.759 77.724V77.772C179.147 78.168 178.799 78.696 178.799 79.248C178.799 80.376 179.891 81 181.487 81ZM181.487 75.192C180.731 75.192 180.095 74.592 180.095 73.644C180.095 72.684 180.719 72.12 181.487 72.12C182.255 72.12 182.879 72.696 182.879 73.644C182.879 74.592 182.231 75.192 181.487 75.192ZM181.643 80.256C180.467 80.256 179.759 79.8 179.759 79.104C179.759 78.72 179.951 78.336 180.419 78C180.707 78.072 181.019 78.108 181.259 78.108H182.387C183.251 78.108 183.719 78.312 183.719 78.912C183.719 79.596 182.891 80.256 181.643 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M188.505 78.156C189.393 78.156 190.089 77.856 190.665 77.484L190.269 76.764C189.789 77.088 189.273 77.28 188.637 77.28C187.401 77.28 186.549 76.392 186.477 75H190.869C190.893 74.844 190.917 74.616 190.917 74.376C190.917 72.516 189.981 71.316 188.325 71.316C186.813 71.316 185.385 72.636 185.385 74.748C185.385 76.896 186.777 78.156 188.505 78.156ZM186.465 74.208C186.597 72.936 187.413 72.192 188.337 72.192C189.357 72.192 189.957 72.9 189.957 74.208H186.465Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M192.474 78H197.298V77.088H195.534V69.444H194.694C194.214 69.732 193.65 69.936 192.87 70.068V70.776H194.43V77.088H192.474V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var Svg1BannerGrey = function Svg1BannerGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 145,
    viewBox: "0 0 356 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg1BannerGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1banner_grey.4154ce11.svg";
export { ForwardRef as ReactComponent };